const getCurrency = (prices, currency) => {
  let dataEUR = prices.filter(price => price.currency === "EUR")
  let dataUSD = prices.filter(price => price.currency === "USD")

  return currency ? dataEUR : dataUSD
}

export default getCurrency
